import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '../services/translate.service';

@Pipe({
  name: 'translate',
  pure: false,
})
export class TranslatePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: string, args?: any[], notHtml?: boolean): string {
    let res = this.translate.data[value] || value;
    if (args) {
      for (let i = 0; i < args.length; i++) {
        res = res.replace(
          `{${i}}`,
          notHtml
            ? this.translate.data[`${args[i]}`] || `${args[i]}`
            : this.translate.data[`${args[i]}`] != null
            ? '<b>' + this.translate.data[`${args[i]}`] + '</b>'
            : `<b>${args[i]}</b>`
        );
      }
    }
    return res;
  }
}
